import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/home/Home.vue";
import login from "../views/login.vue";
// import login1 from "../views/login1.vue";
// import jinanlogin from "../views/jinanlogin.vue";
const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

import store from "../store";
const _import_ = (file) => () => import("@/views/" + file + ".vue");
// var loginComp =
// 	window.location.host.indexOf("wenwu") > -1 ? login1 : window.location.host.indexOf("tongxin") > -1 ? jinanlogin : login;

// 上线注销
// loginComp = jinanlogin;

Vue.use(VueRouter);

export const routes = [
	// 数据分析单位页
	{
		path: '/unit',
		name: 'unit',
		component: _import_("report/analysisUnit"),
		meta: { unit: true }
	},
	{
		path: '/openMap',
		name: 'openMap',
		component: resolve => require(['../views/home/components/openLaysModel'], resolve),
	},
	{
		path: "/Homepage1",
		name: "HomePage1",
		component: resolve => require(['../views/home/newHome.vue'], resolve),
		meta: { newHome: true },
	},
	{
		path: "/",
		name: "Home",
		component: Home,
		meta: { ishome: true },
	},

	{
		path: "/wenwu/files/add",
		name: "/wenwu/files/add",
		component: _import_("wenwu/dangan/add"),
	},
	{
		path: "/report/analysis",
		name: "/report/analysis",
		component: _import_("report/analysis/index"),
	},
	// 操作日志
	{
		path: "/log",
		name: "log",
		component: _import_("log/index"),
		meta: {
			name: 'log',
			nacy: "true",//是否不做token验证
		},
	},
	{
		path: "/check",
		name: "check",
		component: _import_("check/index"),
	},
	{
		path: "/check/checkrecord",
		name: "checkrecord",
		component: _import_("check/checkrecord"),
	},
	{
		path: "/facility",
		name: "facility",
		component: _import_("facility/index"),
	},
	{
		path: "/facility/role",
		name: "facility/role",
		component: _import_("facility/role"),
	},
	{
		path: "/login",
		name: "login",

		component: login,
		meta: { login: true },
	},
	{
		//表单demo
		path: "/form-demo",
		name: "form-demo",
		component: _import_("form-demo"),
	},
	{
		//上传demo
		path: "/upload-demo",
		name: "upload-demo",
		component: _import_("upload-demo"),
	},
	{
		//单位列表
		path: "/company/company-list",
		name: "company-list",
		meta: {
			keepAlive: true, // 开启缓存
		},
		component: _import_("company/list"),
	},
	{
		//建筑消防设施管理
		path: "/fireFacilities/managementFacilities",
		name: "managementFacilities",
		// meta: {
		// 	keepAlive: true, // 开启缓存
		// },
		component: _import_("fireFacilities/managementFacilities"),
	},
	{
		//单位编辑
		path: "/company/company-edit",
		name: "company-edit",
		component: _import_("company/edit"),
	},
	{
		//单位添加
		path: "/company/company-add",
		name: "company-add",
		component: _import_("company/add"),
	},
	{
		//角色列表
		path: "/power/role-list",
		name: "/power/role-list",
		meta: {
			keepAlive: true, // 开启缓存
		},
		component: _import_("role/role-list"),
	},
	// { //角色列表
	//     path: '/system/role',
	//     name: '/system/role',
	//     meta: {
	//         keepAlive: true // 开启缓存
	//       },
	//     component: _import_('system/role/index')
	// },
	// 菜单管理
	{
		path: "/system/menu/index",
		name: "/menu/menu",
		component: _import_("system/menu/index"),
	},
	// 字典管理
	{
		path: "/system/dict/index",
		name: "/dict/index",
		component: _import_("system/dict/index"),
	},
	// 字典管理-字典类型
	{
		path: "/dict/data",
		name: "/dict/data",
		component: _import_("system/dict/data"),
	},

	{
		//角色列表
		path: "/system/role-add",
		name: "/system/role-add",

		component: _import_("system/role/roleAdd"),
	},
	{
		//角色添加
		path: "/power/role-add",
		name: "/power/role-add",
		component: _import_("role/role-add"),
	},
	{
		//角色修改
		path: "/power/role-edit",
		name: "/power/role-edit",
		component: _import_("role/role-edit"),
	},
	// { //人员列表
	//     path: '/power/user-list',
	//     name: '/power/user-list',
	//     meta: {
	//         keepAlive: true // 开启缓存
	//       },
	//     component: _import_('system/user/user-list')
	// },
	{
		//人员添加
		path: "/power/user-add",
		name: "/power/user-add",
		component: _import_("system/user/user-add"),
	},
	{
		//权限列表
		path: "/power/power-list",
		name: "/power/power-list",
		meta: {
			keepAlive: true, // 开启缓存
		},
		component: _import_("power/power-list"),
	},
	{
		//权限添加
		path: "/power/power-add",
		name: "/power/power-add",
		component: _import_("power/power-add"),
	},
	{
		//权限添加
		path: "/power/power-edit",
		name: "/power/power-edit",
		component: _import_("power/power-edit"),
	},
	{
		//设备列表
		path: "/device/device-list",
		name: "/device/device-list",
		component: _import_("device/device-list"),
	},
	{
		//设备添加
		path: "/device/device-add",
		name: "/device/device-add",
		component: _import_("device/device-add"),
	},
	{
		//设备编辑
		path: "/device/device-edit",
		name: "/device/device-edit",
		component: _import_("device/device-edit"),
	},
	{
		//实时状态
		path: "/status/real-list",
		name: "/status/real-list",
		component: _import_("status/real-list"),
	},
	{
		//实时状态
		path: "/status/online-list",
		name: "/status/online-list",
		component: _import_("status/online-list"),
	},
	{
		//安全巡检-安排计划
		path: "/safe/safe-plan",
		name: "/safe/safe-plan",
		component: _import_("safe/safe-plan"),
	},
	{
		//安全巡检-安全管理
		path: "/safe/safe-manage",
		name: "/safe/safe-manage",
		component: _import_("safe/safe-manage"),
	},
	{
		//安全巡检-安全记录
		path: "/safe/safe-record",
		name: "/safe/safe-record",
		// meta:{keepAlive:true},

		component: _import_("safe/safe-record"),
	},
	{
		//安全巡检-安全记录详情
		path: "/safe/recordwwdetail",
		name: "/safe/recordwwdetail",
		component: _import_("safe/safe-recordwwdetail"),
	},
	{
		//安全巡检-安全记录详情
		path: "/safe/recorddetail",
		name: "/safe/recorddetail",
		component: _import_("safe/safe-recorddetail"),
	},
	//安全巡检-隐患详情
	{
		//安全巡检-安全记录详情
		path: "/safe/rescureddetail",
		name: "/safe/rescureddetail",
		component: _import_("safe/safe-rescureddetail"),
	},

	{
		//安全巡检-巡查隐患管理
		path: "/wenwu/safe-danger",
		name: "/wenwu/safe-danger",
		// meta: {
		//     keepAlive: true // 开启缓存
		//   },
		component: _import_("wenwu/safe-danger"),
	},
	{
		//安全巡检-巡查隐患管理详情
		path: "/wenwu/safe-danger-detail",
		name: "/wenwu/safe-danger-detail",
		// meta: {
		//     keepAlive: true // 开启缓存
		//   },
		component: _import_("wenwu/safe-danger-detail"),
	},
	{
		//安全巡检-巡查方案管理
		path: "/wenwu/safe-programme",
		name: "/wenwu/safe-programme",
		// meta: {
		//     keepAlive: true // 开启缓存
		//   },
		component: _import_("wenwu/safe-programme"),
	},
	{
		//安全巡检-巡查方案管理
		path: "/wenwu/safe-programme-detail",
		name: "/wenwu/safe-programme-detail",
		// meta: {
		//     keepAlive: true // 开启缓存
		//   },
		component: _import_("wenwu/safe-programme-detail"),
	},
	{
		//安全巡检-巡查方案管理
		path: "/wenwu/safe-record",
		name: "/wenwu/safe-record",
		// meta: {
		//     keepAlive: true // 开启缓存
		//   },
		component: _import_("wenwu/safe-record"),
	},
	{
		//安全巡检-安全记录详情
		path: "/wenwu/recorddetail",
		name: "/wenwu/recorddetail",
		component: _import_("wenwu/safe-recorddetail"),
	},

	{
		//安全巡检-巡查点管理列表
		path: "/safe/safe-placeList",
		name: "/safe/safe-placeList",
		// meta: {
		//     keepAlive: true // 开启缓存
		//   },
		component: _import_("safe/safe-placeList"),
	},

	{
		//安全巡检-巡查数据
		path: "/safe/safe-statistics",
		name: "/safe/safe-statistics",
		component: _import_("safe/safe-statistics"),
	},
	{
		//安全巡检-巡查人员
		path: "/safe/safe-userList",
		name: "/safe/safe-userList",
		meta: {},
		component: _import_("safe/safe-userList"),
	},

	{
		path: "/safe/safe-time",
		name: "/safe/safe-time",
		meta: {},
		component: _import_("safe/safe-time"),
	},
	{
		//安全巡检-巡查统计
		path: "/safe/safe-timer",
		name: "/safe/safe-timer",
		component: _import_("safe/safe-timer"),
	},
	{
		//安全巡检-巡查时间
		path: "/safe/safe-area",
		name: "/safe/safe-area",
		component: _import_("safe/safe-area"),
	},
	{
		//安全巡检-巡查人员列表
		path: "/safe/safe-adduser",
		name: "/safe/safe-adduser",
		component: _import_("safe/safe-adduser"),
	},

	{
		path: "/company/wenwu-list",
		name: "/company/wenwu-list",
		meta: {
			keepAlive: true, // 开启缓存
		},
		component: _import_("company/wenwu"),
	},
	{
		path: "/company/wenwu-add",
		name: "/company/wenwu-add",
		component: _import_("company/addwenwu"),
	},
	{
		path: "/safe/safe-rescured",
		name: "/safe/safe-rescured",
		// meta:{keepAlive:true},

		component: _import_("safe/safe-rescured"),
	},
	{
		path: "/safe/safe-add",
		name: "/safe/safe-add",
		component: _import_("safe/safe-add"),
	},
	{
		path: "/safe/safe-wwadd",
		name: "/safe/safe-wwadd",
		component: _import_("safe/safe-wwadd"),
	},
	//添加巡查点
	{
		path: "/safe/safe-addpoint",
		name: "/safe/safe-addpoint",
		component: _import_("safe/safe-addpoint"),
	},
	{
		path: "/safe/safe-addwwpoint",
		name: "/safe/safe-addwwpoint",
		component: _import_("safe/safe-addwwpoint"),
	},
	{
		path: "/check/auto-check",
		name: "/auto-check",
		component: _import_("check/alarm-check"),
	},

	{
		path: "/pinggu/pinggu-list",
		name: "/pinggu",
		component: _import_("pinggu/pglist"),
	},
	//电气统计详情
	{
		path: "/report/electronic-static",
		name: "/elect-static",
		component: _import_("report/reportele"),
	},
	{
		path: "/check/auto-add",
		name: "/auto-add",
		component: _import_("check/auto-add"),
		meta: { report_aaa: true }
	},
	{
		path: "/report/report-list",
		name: "/Report/report-list",
		component: _import_("report/report-list"),
		meta: { report_List: true }
	},
	// {
	//     path:'/report/report-detail',
	//     name: '/report-detail',
	//     component: _import_('report/report-detail')
	// },
	{
		path: "/report/report-detail",
		name: "/report-detail",
		component: _import_("report/report-details"),
	},
	{
		path: "/report/electronic-detail",
		name: "/electronic-detail",
		component: _import_("report/report-detail"),
	},
	{
		path: "/report/report-baolist",
		name: "/report-baolist",
		component: _import_("report/report-baolist"),
	},
	{
		path: "/report/report-smartfire",
		name: "report-smartfire",
		component: _import_("report/report-smartFire"), /*智慧消防*/
	},
	{
		path: "/building",
		name: "/building",
		component: _import_("bim/bim"),
	},
	{
		path: "/shenqing",
		name: "/shenqing",
		component: _import_("minishenhe/shenqing"),
	},
	{
		path: "/device/static",
		name: "/device/static",
		component: _import_("status/online-list"),
	},
	//CRT点位管理
	{
		path: "/qvyu/qvyuList",
		name: "/qvyu/qvyuList ",
		component: _import_("CRTpoint/crtList"),
	},
	//crt 添加
	{
		path: "/qvyu/video-add",
		name: "/qvyu/video-add",
		component: _import_("CRTpoint/videoadd"),
	},
	// crt 摄像头
	{
		path: "/qvyu/videoList",
		name: "/qvyu/videoList",
		component: _import_("CRTpoint/videoList"),
	},
	//添加摄像头
	//crt 添加
	{
		path: "/qvyu/qvyu-add",
		name: "/qvyu/qvyu-add ",
		component: _import_("CRTpoint/qvyu-add"),
	},
	// 区域地质
	{
		path: "/qvyu/qvyu-place",
		name: "/qvyu/qvyu-place",
		component: _import_("CRTpoint/qvyuplace"),
	},
	//添加区域
	{
		path: "/qvyu/qvyu-place-add",
		name: " /qvyu/qvyu-place-add",
		component: _import_("CRTpoint/qvyuplace-add"),
	},
	// crt 标注
	{
		path: "/qvyu/qvyu-mark",
		name: " /qvyu/qvyu-mark",
		component: _import_("CRTpoint/crtmark"),
	},
	{
		path: "/qvyu/qvyu-test",
		name: " /qvyu/qvyu-test",
		component: _import_("CRTpoint/testcanvas"),
	},
	//接警详情

	{
		path: "/jiejing/jiejingdetail",
		name: "/jiejing/jiejingdetail",
		component: _import_("jiejing/jiejingdetail"),
	},

	{
		path: "/company/dianwei",
		name: "/company/dianwei",
		component: _import_("company/place"),
	},

	{
		path: "/company/dianwei-add",
		name: "/company/dianwei-add",
		component: _import_("company/dianwei-add"),
	},

	{
		path: "/company/ignoreList",
		name: "/company/ignoreList",
		component: _import_("company/ignorePlace"),
	},
	{
		path: "/webview",
		name: "/webview",
		component: _import_("webview"),
	},

	{
		path: "/3ddemo",
		name: "/3ddemo",
		component: _import_("3dmap"),
	},
	{
		path: "/plan/person",
		name: "/plan-person",
		component: _import_("plan/person"),
	},
	{
		path: "/plan/build-device",
		name: "/build-device",
		component: _import_("plan/builddevice"),
	},
	{
		path: "/plan/notice",
		name: "/plan-notice",
		component: _import_("plan/notice"),
	},
	{
		path: "/plan/mumber",
		name: "/plan-mumber",
		component: _import_("plan/addmumber"),
	},
	{
		path: "/plan/drillrecord",
		name: "/plan-drillrecord",
		// meta:{
		//     keepAlive:true
		// },
		component: _import_("plan/drillrecord"),
	},
	{
		path: "/plan/drillList",
		name: "/plan/drillList",
		// meta:{
		//     keepAlive:true
		// },
		component: _import_("plan/drill-list"),
	},
	{
		path: "/plan/firerecord",
		name: "/plan-firerecord",
		// meta:{
		//     keepAlive:true
		// },
		component: _import_("plan/firerecord"),
	},
	// 灭火记录
	{
		path: "/plan/fireExtionguishingDetails",
		name: "/fireExtionguishingDetails",
		// meta:{
		//     keepAlive:true
		// },
		component: _import_("plan/fireExtionguishingDetails"),
	},
	{
		path: "/plan/plan-add",
		name: "/plan-add",
		component: _import_("plan/plan-add"),
	},
	{
		// 编辑预案 重构
		path: "/plan/planEditing",
		name: "/planEditing",
		component: _import_("plan/planEditing"),
	},
	{
		path: "/plan/plan-record",
		name: "/plan-record",
		component: _import_("plan/plan-record"),
	},
	{
		path: "/plan/necessary",
		name: "/plan/necessary",
		component: _import_("plan/necessary"),
	},
	{
		path: "/product",
		name: "/product",
		component: _import_("product"),
	},
	{
		path: "/score/detail",
		name: "/score/detail",
		component: _import_("score/scoreDt"),
	},
	{
		path: "/score/scoreList",
		name: "/score/scoreList",
		component: _import_("score/scoreList"),
	},
	{
		//单位列表
		path: "/company/taskList",
		name: "taskList",
		component: _import_("company/point"),
	},
	{
		//评估评分
		path: "/score/assessScore",
		name: "assessScore",
		component: _import_("score/assessScore"),
	},
	{
		//'新增'按钮，评估任务页面
		path: "/company/detailsOfAssess",
		name: "detailsOfAssess",
		component: _import_("company/detailsOfAssess"),
	},
	{
		//'详情'按钮，评估详情页面
		path: "/company/assessList",
		name: "assessList",
		component: _import_("company/assessList"),
	},
	{
		//单位评分编辑
		path: "/company/pointDetail",
		name: "pointDetail",
		component: _import_("company/point-add"),
	},
	// 单位集团列表
	{
		path: "/company/group-add",
		name: "/company/group-add",
		component: _import_("company/group-add"),
	},
	{
		path: "/company/point",
		name: "/company/company-point",
		meta: { keepAlive: true },
		component: _import_("company/pointTask"),
	},
	{
		path: "/company/taskDetail",
		name: "/company/taskDetail",
		component: _import_("company/taskAdd"),
	},
	// 文旅
	{
		path: "/wenlv/index",
		name: "/wenlv/index",
		component: _import_("wenlv/index"),
	},
	{
		path: "/wenlv/inspectionArea",
		name: "/wenlv/inspectionArea",
		component: _import_("wenlv/inspectionArea"),
	},
	{
		path: "/wenlv/inspectionPoints",
		name: "/wenlv/inspectionPoints",
		component: _import_("wenlv/inspectionPoints"),
	},
	{
		path: "/wenlv/inspectionPerson",
		name: "/wenlv/inspectionPerson",
		component: _import_("wenlv/inspectionPerson"),
	},
	{
		path: "/wenlv/inspectionDanger",
		name: "/wenlv/inspectionDanger",
		component: _import_("wenlv/inspectionDanger"),
	},
	{
		path: "/wenlv/inspectionDangerDetail",
		name: "/wenlv/inspectionDangerDetail",
		component: _import_("wenlv/inspectionDangerDetail"),
	},
	{
		path: "/wenlv/inspectionStatistics",
		name: "/wenlv/inspectionStatistics",
		component: _import_("wenlv/inspectionStatistics"),
	},
	{
		path: "/wenlv/inspectionChart",
		name: "/wenlv/inspectionChart",
		component: _import_("wenlv/inspectionChart"),
	},
	{
		path: "/wenlv/inspectionRecord",
		name: "/wenlv/inspectionRecord",
		component: _import_("wenlv/inspectionRecord"),
	},
	{
		path: "/wenlv/indexAdd",
		name: "/wenlv/indexAdd",
		component: _import_("wenlv/indexAdd"),
	},
	{
		path: "/wenlv/inspectionAddpoint",
		name: "/wenlv/inspectionAddpoint",
		component: _import_("wenlv/inspectionAddpoint"),
	},
	{
		path: "/wenlv/inspectionAddPerson",
		name: "/wenlv/inspectionAddPerson",
		component: _import_("wenlv/inspectionAddPerson"),
	},
	{
		path: "/wenlv/inspectionPersonEdit",
		name: "/wenlv/inspectionPersonEdit",
		component: _import_("wenlv/inspectionPersonEdit"),
	},
	{
		path: "/wenlv/inspectionTask",
		name: "/wenlv/inspectionTask",
		component: _import_("wenlv/inspectionTask"),
	},
	{
		path: "/wenlv/inspectionTaskCreat",
		name: "/wenlv/inspectionTaskCreat",
		component: _import_("wenlv/inspectionTaskCreat"),
	},
	{
		path: "/wenlv/inspectionTaskDetail",
		name: "/wenlv/inspectionTaskDetail",
		component: _import_("wenlv/inspectionTaskDetail"),
	},
	{
		path: "/wenlv/inspectionRecordDetail",
		name: "/wenlv/inspectionRecordDetail",
		component: _import_("wenlv/inspectionRecordDetail"),
	},
	{
		path: "/wenlv/relicFiles",
		name: "/wenlv/relicFiles",
		component: _import_("wenlv/relicFiles"),
	},
	{
		path: "/wenlv/relicFilesAdd",
		name: "/wenlv/relicFilesAdd",
		component: _import_("wenlv/relicFilesAdd"),
	},
	// 电子档案单位报告管理inspectionRecordDetail
	{
		path: "/report/report-company",
		name: "/report/report-company",
		component: _import_("wenwu/company-report"),
	},
	{
		path: "/report/program",
		name: "/report/program",
		component: _import_("wenwu/program-report"),
	},
	// 项目报告管理
	{
		path: "/report/report-program",
		name: "/report/report-program",
		component: _import_("wenwu/program-report"),
	},
	// 报告详情列表
	{
		path: "/report/detail-list",
		name: "/report/detail-list",
		component: _import_("wenwu/detail-list"),
	},
	// 项目管理
	{
		path: "/report/program-list",
		name: "/report/program-list",
		component: _import_("wenwu/program-list"),
	},

	{
		path: "/job/log",
		name: "/job/log",
		component: _import_("system/job/log"),
	},
	// wenwu:program:query详情列表
	{
		path: "/report/detail-proList",
		name: "/report/detail-proList",
		component: _import_("wenwu/detai-proList"),
	},
	{
		path: "/report/detail",
		name: "/report/detail",
		component: _import_("wenwu/detail"),
	},

	{
		//单位列表
		path: "/archives/fireArchives",
		name: "archives/fireArchives",
		meta: {
			keepAlive: true, // 开启缓存
		},
		component: _import_("plan/index"),
	},
	{
		//单位列表
		path: "/plan/manage",
		name: "plan-manage",
		meta: {
			keepAlive: true, // 开启缓存
		},
		component: _import_("plan/manage"),
	},
	{
		path: "/editTitle",
		name: "/editTitle",
		component: _import_("home/editTitle"),
		meta: { editName: true },
	},
	{
		path: "/newEditTitle",
		name: "/newEditTitle",
		component: _import_("home/newEditTitle"),
		meta: { editName: true }
	},

	{
		path: '/report/video',
		name: 'report/video',
		component: _import_("facility/tab4"),
	},
	{
		path: "/404",
		name: "/404",
		component: _import_("404"),
	},

	// {
	//     path: "*", // 此处需特别注意置于最底部
	//     redirect: "/404"
	// }
];

if (store.state.isDev) {
	//开发环境
	routes.push({
		path: "/makeForm",
		name: "makeForm",
		meta: { keepAlive: true },
		component: _import_("makeForm"),
	});
}



const router = new VueRouter({
	routes,
	base: process.env.BASE_URL
});

export default router;
